export default class TaxWithHeld {
  /** @type {string} */ taxType = '04'
  /** @type {number} */ taxRate = null
  /** @type {number} */ cuota = null
}
